import { render, staticRenderFns } from "./phone-block.vue?vue&type=template&id=19e1c3e9&scoped=true"
import script from "./phone-block.vue?vue&type=script&lang=js"
export * from "./phone-block.vue?vue&type=script&lang=js"
import style0 from "./phone-block.vue?vue&type=style&index=0&id=19e1c3e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e1c3e9",
  null
  
)

export default component.exports